import Link from "next/link";
import React from "react";
import Tags from "@components/Tags";
import { ImgSrc } from "@config/image";
import theme from "@config/theme";
import BlogPost from "@components/blog/BlogPost";
import { formatPublishDate, stringToURI } from "@scripts/utils";
import AuthorMetaData from "./AuthorMetaData";

interface BlogPostProps {
  featuredPost: BlogPost;
}

const FeaturedBlog = ({ featuredPost }: BlogPostProps) => (
  <>
    <div className="featured-container">
      <div className="featured-banner">
        <Link
          href={`/blog/${featuredPost.slug}`}
          passHref
          className="article-link"
        >
          <img
            alt={`${featuredPost.title} banner`}
            src={ImgSrc(featuredPost.banner)}
            className="featured-image"
          />
        </Link>
      </div>
      <div className="featured-content">
        <p className="date">{formatPublishDate(featuredPost.publishedAt)}</p>

        <Link
          href={`/blog/${featuredPost.slug}`}
          passHref
          className="article-link"
        >
          <h2 className="title">{featuredPost.title}</h2>
        </Link>

        <p className="excerpt">{featuredPost.excerpt}</p>
        <Tags
          tags={featuredPost.tags.map((tag) => ({
            name: tag,
            url: `/blog/tag/${stringToURI(tag)}`,
          }))}
        />

        <AuthorMetaData author={featuredPost.author} />
      </div>
    </div>
    <style jsx>{`
      .featured-container {
        display: flex;
        gap: 2rem;
        justify-content: flex-start;
        align-items: center;
        max-width: 1100px;
        margin: 3rem auto;
      }
      @media screen and (max-width: ${theme.breakpoints.md}px) {
        .featured-container {
          flex-direction: column;
          align-items: flex-start;
          gap: 1rem;
        }
      }
      .featured-banner {
        flex: 0 0 auto;
        width: clamp(300px, 100%, 450px);
      }
      .featured-content {
        flex: 1 1 auto;
      }

      .title {
        color: ${theme.colors.black};
        margin: 0;
      }
      .title:hover {
        color: ${theme.colors.ultramarine};
      }
      .excerpt {
        margin: 0.5rem 0;
      }
      .date {
        color: ${theme.colors.gray3};
        margin: 0;
      }

      .featured-image {
        height: auto;
        width: 100%;
        border-radius: 4px;
        box-shadow: ${theme.misc.boxShadowBlogImage};
      }
    `}</style>
  </>
);

export default FeaturedBlog;
